import { Navigate, Outlet, NavLink, useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { LogOut } from 'lucide-react'

export function getAdminToken() {
  return localStorage.getItem('slv_admin_token')
}

export function setAdminToken(token: string | null) {
  if (token) localStorage.setItem('slv_admin_token', token)
  else localStorage.removeItem('slv_admin_token')
}

export default function AdminLayout() {
  const token = getAdminToken()
  const navigate = useNavigate()

  if (!token) {
    return <Navigate to="/admin/login" replace />
  }

  const logout = () => {
    setAdminToken(null)
    navigate('/admin/login')
  }

  const links = [
    { to: '/admin', label: 'Overview', end: true },
    { to: '/admin/missions', label: 'Missions', end: false },
    { to: '/admin/upload', label: 'Upload', end: false },
  ]

  return (
    <div className="min-h-screen flex flex-col bg-canvas">
      <header className="sticky top-0 z-40 border-b border-line/80 bg-canvas/80 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-3">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-control border border-line bg-canvas-raised font-mono text-sm font-semibold text-accent">
                SL
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display text-[15px] font-semibold tracking-tight text-ink">
                  StatsLogger
                </span>
                <span className="mt-1 text-[10px] uppercase tracking-[0.18em] text-accent-text">
                  Admin
                </span>
              </span>
            </span>
            <nav className="hidden sm:flex items-center gap-0.5 rounded-panel border border-line bg-canvas-raised/60 p-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  className={({ isActive }) =>
                    cn(
                      'rounded-control px-3.5 py-1.5 text-sm font-medium transition-all duration-200',
                      isActive
                        ? 'bg-canvas-overlay text-accent-text shadow-sm'
                        : 'text-ink-muted hover:text-ink',
                    )
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <button type="button" className="btn-ghost !py-1.5" onClick={logout}>
            <LogOut size={14} /> Logout
          </button>
        </div>
        <nav className="sm:hidden flex border-t border-line px-2 py-1.5 gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                cn(
                  'flex-1 text-center rounded-control py-2 text-xs font-medium transition-colors',
                  isActive ? 'bg-canvas-overlay text-accent-text' : 'text-ink-muted',
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="flex-1 mx-auto w-full max-w-7xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
